import { FC } from 'react';
import { Container } from 'atoms/Container';
import { AlphabeticalItemsPage } from 'organisms/AlphabeticalItemsPage';
import { getBrandsBlok } from 'modules/stroyblok/api';
import { IServerProps } from '../types';

export const AllBrandsBlock: FC<{
  serverProps: IServerProps;
}> = async ({ serverProps }) => {
  const brands = await getBrandsBlok(serverProps.params?.locale);

  return (
    <Container>
      <AlphabeticalItemsPage tKey={'brands-page.title'} items={brands} />
    </Container>
  );
};
